module.exports = __webpack_public_path__ + "zm.acad9df9.svg";